import {useCurrentContactPerson} from '@sdox/api'
import {LinkButton} from '@sdox/ui'

interface VCardButtonProps {
  className?: string
}

export const VCardButton = ({className}: VCardButtonProps) => {
  const contactPerson = useCurrentContactPerson()
  if (!contactPerson || !contactPerson.vcard) {
    return null
  }

  return (
    <LinkButton
      href={`data:text/vcard;charset=UTF-8,${encodeURIComponent(
        contactPerson.vcard,
      )}`}
      download={'contact.vcf'}
      variant={'filled-brand'}
      size={'medium'}
      className={className}
      mboAttrs={{
        prefix: 'ContactPersonDialog',
        piece: 'VCardDownload',
      }}
    >
      Kontakt speichern
    </LinkButton>
  )
}
